/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Voice_Selected_ToastInputs */

const en_settings_voice_selected_toast = /** @type {(inputs: Settings_Voice_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your selected voice will apply to all future uploads. Files already uploaded won't be affected`)
};

const es_settings_voice_selected_toast = /** @type {(inputs: Settings_Voice_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu voz seleccionada se aplicará a todas las subidas futuras. Los archivos ya subidos no se verán afectados`)
};

/**
* | output |
* | --- |
* | "Your selected voice will apply to all future uploads. Files already uploaded won't be affected" |
*
* @param {Settings_Voice_Selected_ToastInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_voice_selected_toast = /** @type {((inputs?: Settings_Voice_Selected_ToastInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Voice_Selected_ToastInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_voice_selected_toast(inputs)
	return en_settings_voice_selected_toast(inputs)
});